import { render, staticRenderFns } from "./Periode.vue?vue&type=template&id=5013cdfe&"
import script from "./Periode.vue?vue&type=script&lang=ts&"
export * from "./Periode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports